import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { addOverlay, removeOverlay } from '../Actions/Overlay.action';

const StickyBottomModal = (props) => {
  const { children, title, open, onClose, extraContentAbove } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      dispatch(addOverlay('StickyBottomModal', onClose));
    } else {
      dispatch(removeOverlay('StickyBottomModal'));
    }
  }, [open]);
  return open
    ? createPortal(
        <div className="sticky-bottom-modal">
          {extraContentAbove && (
            <div className="sticky-bottom-modal__extra-content">
              {extraContentAbove}
            </div>
          )}
          <div className="sticky-bottom-modal__body">
            <div className="[ sticky-bottom-modal__header ] [ text-large color-grey-900 bold ]">
              {title}
              <div onClick={onClose}>
                <i className="ph-x"></i>
              </div>
            </div>
            <div className="sticky-bottom-modal__content">{children}</div>
          </div>
        </div>,
        document.body
      )
    : null;
};

export default StickyBottomModal;
